// extracted by mini-css-extract-plugin
module.exports = {"menuList":"MenuList_menuList__5TkHL","channels":"MenuList_channels__36JAI","shortcuts":"MenuList_shortcuts__MGBS7"};